import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Project } from '../../models/report';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent implements OnInit{
  @Input() data!: Project[];
  @Input() columns: any[] = [];
  @Input() customBodyTemplate!: TemplateRef<any>;
  @Input() tableNullData:string = 'No Data Found';
  @Input() haveTableChecboxes:boolean = false;
  @Input() haveRowEditButton:boolean = false;
  @Input() haveRowDeleteButton:boolean = false;
  @Input() editableListing: boolean = false;
  @Input() editingRowId: boolean = false;
  @Output() onResetRowData = new EventEmitter<any>();
  @Output() onSaveRowData = new EventEmitter<any>();
  @Input() tableScrollHeight:string = '';
  @Output() onViewData = new EventEmitter<any>;
  @Output() onEditData = new EventEmitter<any>;
  @Output() onRowSelection = new EventEmitter<any>;
  @Input() selectedProject!: Project;
  @Input() firstPage: number = 0;
  @Input() pageSize: number = 10;
  @Input() totalCount: number = 0;
  @Input() loading: boolean = false;
  @Input() addRowButtonDisabled: boolean = false;
  @Output() pageChange = new EventEmitter<any>();
  activeOverlayPanel: OverlayPanel | null = null;

  ngOnInit() {
    
  }
  getStyle(item: any) {
    let styles: { [key: string]: string };

    if(this.haveRowEditButton || this.haveRowDeleteButton){
        styles = {
            'empName': '180px',
            'empId': '150px',
            'synced': '200px',
            'is_active': '115px',
            'name': '145px',
            'email': '145px',
            'phone': '105px',
            '': '90px',
            'default': 'auto'
        };
    } else {
        styles = {
            'empName': '180px',
            'empId': '150px',
            'synced': '200px',
            'posted_at':'200px',
            'created_at':'200px',
            'connected_at': '200px',
            'default': 'auto'
        };
    }

    return {
        'min-width': styles[item.field] || styles['default']
    };
  }
  getEditableTableStyle(item: any){
    const styles: { [key: string]: string } = {
      '': '120px',
      'default': 'auto',
      'permissions': '400px'
    };
  
    return {
      'width': styles[item.field] || styles['default']
    };
  }
  onPageChange(event: any) {
    this.pageChange.emit(event);  // Emit page change event to parent
  }
  rowSelection(){
    this.onRowSelection.emit(this.selectedProject);
  }
  viewData(rowData: any){
    this.selectedProject;
    this.onViewData.emit(rowData);
  }
  editData(rowData: any){
    this.onEditData.emit(rowData);
  }
  saveRowData(rowData:any) {
    this.onSaveRowData.emit(rowData);
  }
  resetRowData(rowData:any,obj: any) {
    const payload = { rowData, obj };
    this.onResetRowData.emit(payload);
  }


  toggleOverlayPanel(event: Event, overlayPanel: OverlayPanel) {
    // If an overlay panel is already open, close it
    if (this.activeOverlayPanel && this.activeOverlayPanel !== overlayPanel) {
      this.activeOverlayPanel.hide();
    }

    // Toggle the clicked overlay panel
    overlayPanel.toggle(event);

    // Update the activeOverlayPanel only when it's not already active
    if (this.activeOverlayPanel === overlayPanel) {
      this.activeOverlayPanel = null;
    } else {
      this.activeOverlayPanel = overlayPanel;
    }
  }

  onOverlayShow(overlayPanel: OverlayPanel) {
    // Set the currently shown overlay panel as active
    this.activeOverlayPanel = overlayPanel;
  }

  onOverlayHide(overlayPanel: OverlayPanel) {
    // If the active overlay is hidden, clear the reference
    if (this.activeOverlayPanel === overlayPanel) {
      this.activeOverlayPanel = null;
    }
  }
}
